<div class="container-fluid ">
    <div class="card rounded-4 shadow-lg border-0 w-100" style="height: 90vh; background-color: #fff;">
        <div class="row h-100 ">

            <!-- Left Section: Image -->
            <div class="col-lg-3 col-md-12 d-flex justify-content-center align-items-center">
                <div class="left-section text-center">
                    <img [src]="stepImages[activeStep]" alt="Step Illustration" class="img-fluid" />
                </div>
            </div>


            <!-- Separator (Independent) -->
            <div class="col-auto d-flex justify-content-center align-items-center">
                <div class="separator mx-1"></div>
            </div>

            <!-- Right Section: Stepper -->
            <div class="col-lg-8 col-md-12 p-4">
                <div class="right-section d-flex flex-column h-100">

                    <!-- Stepper Component -->
                    <div
                        class="horizontal-stepper d-flex flex-wrap justify-content-center justify-content-md-between align-items-center mb-4 gap-3">
                        <ng-container *ngFor="let step of steps; let i = index">
                            <div class="step-wrapper d-flex align-items-center flex-nowrap mb-2 mb-md-0">
                                <div class="step text-center"
                                    [ngClass]="{ 'active': i === activeStep, 'completed': i < activeStep }"
                                    (click)="setStep(i)" style="cursor: pointer;">
                                    <div class="step-container d-flex flex-column align-items-center text-center">
                                        <div class="circle d-flex align-items-center justify-content-center mb-2">
                                            <i [ngClass]="step.icon"></i>
                                        </div>
                                        <div class="title">{{ step.title }}</div>
                                    </div>
                                </div>

                                <!-- Line only between steps -->
                                <ng-container *ngIf="i !== steps.length - 1">
                                    <div class="step-line" [ngClass]="{ 'completed': i < activeStep }"></div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>



                    <!-- Step Content -->

                    <div class="step-content flex-grow-1 overflow-auto">
                        <div class="p-4 border rounded shadow-sm h-100 d-flex flex-column">
                            <ng-container *ngIf="activeStep === 0; else defaultContent">

                                <!-- Form Area -->
                                <form [formGroup]="propertyForm" (ngSubmit)="submitOverview()" #overviewForm="ngForm"
                                    class="flex-grow-1 d-flex flex-column">

                                    <div class="fw-bold" style="font-size: 30px; color: #011044;">Overview</div>

                                    <div class="row g-3">

                                        <!-- Fields -->
                                        <div class="overflow-auto pe-2" style="max-height: 60vh;">
                                            <div class="row g-3">
                                                <div class="col-md-6">
                                                    <label class="form-label">Title</label>
                                                    <input type="text" class="form-control shadow-sm"
                                                        formControlName="title" name="name"
                                                        [class.is-invalid]="propertyForm.get('title')?.invalid && propertyForm.get('title')?.touched"
                                                        required>


                                                </div>

                                                <div class="col-md-6">
                                                    <label class="form-label">Property Type</label>
                                                    <select class="form-select" formControlName="propertyType"
                                                        [class.is-invalid]="propertyForm.get('propertyType')?.invalid && propertyForm.get('propertyType')?.touched">
                                                        <option value="">Select Type</option>
                                                        <option *ngFor="let type of propertyTypes" [value]="type">{{
                                                            type }}</option>
                                                    </select>
                                                </div>

                                                <div class="mb-3 col-md-12">
                                                    <label for="description">Description</label>
                                                    <textarea id="description" class="form-control"
                                                        formControlName="description" maxlength="500"
                                                        (input)="updateCharCount()"></textarea>
                                                    <small class="text-muted">{{ charCount }}/500 characters</small>
                                                </div>

                                                <div class="col-md-4">
                                                    <label class="form-label">Listing Type</label>
                                                    <select class="form-select" formControlName="listingType">
                                                        <option value="">Select Listing</option>
                                                        <option *ngFor="let type of listingTypes" [value]="type">{{ type
                                                            }}</option>
                                                    </select>
                                                </div>

                                                <!-- ADDITIONAL FIELDS YOU MENTIONED -->
                                                <div class="col-md-4">
                                                    <label class="form-label">City</label>
                                                    <input formControlName="city" class="form-control" type="text" />
                                                </div>

                                                <div class="col-md-4">
                                                    <label class="form-label">State</label>
                                                    <input formControlName="state" class="form-control" type="text" />
                                                </div>

                                                <div class="col-md-4">
                                                    <label class="form-label">Locality</label>
                                                    <input formControlName="locality" class="form-control"
                                                        type="text" />
                                                </div>

                                                <div class="col-md-8">
                                                    <label class="form-label">Address</label>
                                                    <input formControlName="address" class="form-control" type="text" />
                                                </div>

                                                <div class="col-md-4">
                                                    <label class="form-label">Pincode</label>
                                                    <input formControlName="pincode" class="form-control" type="text" />
                                                </div>

                                                <div class="col-md-4">
                                                    <label class="form-label">Latitude</label>
                                                    <input formControlName="latitude" class="form-control"
                                                        type="text" />
                                                </div>

                                                <div class="col-md-4">
                                                    <label class="form-label">Longitude</label>
                                                    <input formControlName="longitude" class="form-control"
                                                        type="text" />
                                                </div>
                                                <!-- 
                                                     <div class="col-md-6">
                                                         <label class="form-label">Status</label>
                                                         <input formControlName="status" class="form-control" type="text" />
                                                     </div> -->


                                            </div>
                                        </div>

                                        <!-- Spacer to push footer down -->
                                        <div class="flex-grow-1"></div>

                                        <!-- Buttons -->
                                        <div class="d-flex justify-content-end gap-2 pt-3 mt-3 border-top">
                                            <button type="button" class="btn btn-cancel px-4"
                                                (click)="cancelStep()">Cancel</button>
                                            <button type="button" class="btn btn-next px-4"
                                                (click)="goToNextStep()">Next</button>

                                        </div>
                                    </div>
                                </form>
                            </ng-container>

                            <ng-container *ngIf="activeStep === 1">
                                <form [formGroup]="propertyDetailsForm" (ngSubmit)="submitPropertyDetails()"
                                    #propertyForm="ngForm" class="flex-grow-1 d-flex flex-column">
                                    <div class="overflow-auto pe-2" style="max-height: 60vh;">
                                        <div class="row g-3">

                                            <div class="col-md-4">
                                                <label class="form-label">BHK</label>
                                                <input formControlName="bhk" class="form-control" type="number"
                                                    (focus)="handleNumberTypeFocus('bhk')"
                                                    (blur)="handleNumberTypeBlur('bhk')" />
                                            </div>

                                            <div class="col-md-4">
                                                <label class="form-label">Super Area</label>
                                                <input formControlName="superArea" class="form-control" type="number"
                                                    (focus)="handleNumberTypeFocus('superArea')"
                                                    (blur)="handleNumberTypeBlur('superArea')" />
                                            </div>

                                            <div class="col-md-4">
                                                <label class="form-label">Carpet Area</label>
                                                <input formControlName="carpetArea" class="form-control" type="number"
                                                    (focus)="handleNumberTypeFocus('carpetArea')"
                                                    (blur)="handleNumberTypeBlur('carpetArea')" />
                                            </div>


                                            <div class="col-md-6">
                                                <label class="form-label">Furnishing</label>
                                                <select class="form-select" formControlName="furnishing">
                                                    <option value="">Select Furnishing</option>
                                                    <option *ngFor="let item of furnishingOptions" [value]="item">{{
                                                        item }}</option>
                                                </select>
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-label">Floor Number</label>
                                                <input formControlName="floorNumber" class="form-control" type="number"
                                                    (focus)="handleNumberTypeFocus('floorNumber')"
                                                    (blur)="handleNumberTypeBlur('floorNumber')" />
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-label">Total Floors</label>
                                                <input formControlName="totalFloors" class="form-control" type="number"
                                                    (focus)="handleNumberTypeFocus('totalFloors')"
                                                    (blur)="handleNumberTypeBlur('totalFloors')" />
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-label">Age Of Construction</label>
                                                <input formControlName="ageOfConstruction" class="form-control"
                                                    type="number" (focus)="handleNumberTypeFocus('ageOfConstruction')"
                                                    (blur)="handleNumberTypeBlur('ageOfConstruction')" />
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-label">Facing</label>
                                                <select class="form-select" formControlName="facing">
                                                    <option value="">Select Facing</option>
                                                    <option *ngFor="let direction of facingOptions" [value]="direction">
                                                        {{ direction }}</option>
                                                </select>
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-label">Ownership Type</label>
                                                <select class="form-select" formControlName="ownershipType">
                                                    <option value="">Select Ownership</option>
                                                    <option *ngFor="let type of ownershipTypes" [value]="type">{{ type
                                                        }}</option>
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="flex-grow-1"></div>
                                    <div class="d-flex justify-content-end gap-2 pt-3 mt-3 border-top">
                                        <button type="button" class="btn btn-cancel px-4"
                                            (click)="BackStep()">Back</button>
                                        <button type="button" class="btn btn-next px-4"
                                            (click)="goToNextStep()">Next</button>
                                    </div>
                                </form>
                            </ng-container>

                            <ng-container *ngIf="activeStep === 2">
                                <form [formGroup]="propertyAmenitiesForm" (ngSubmit)="submitPropertyDetails()"
                                    #propertyForm="ngForm" class="flex-grow-1 d-flex flex-column">

                                    <label class="form-label">Select Available Amenities</label>
                                    <div class="d-flex flex-wrap gap-2">
                                        <div *ngFor="let amenity of amenitiesList"
                                            class="amenity-icon p-2 rounded d-flex align-items-center gap-2 border"
                                            [ngClass]="{ 'bg-primary text-white': isAmenitySelected(amenity.name) }"
                                            (click)="toggleAmenity(amenity.name)"
                                            style="cursor: pointer; min-width: 150px;">
                                            <i [class]="'bi ' + amenity.icon"></i>
                                            <span>{{ amenity.name }}</span>
                                        </div>
                                    </div>


                                    <div class="flex-grow-1"></div>
                                    <div class="d-flex justify-content-end gap-2 pt-3 mt-3 border-top">
                                        <button type="button" class="btn btn-cancel px-4"
                                            (click)="BackStep()">Back</button>
                                        <button type="button" class="btn btn-next px-4"
                                            (click)="goToNextStep()">Next</button>
                                    </div>
                                </form>
                            </ng-container>

                            <ng-container *ngIf="activeStep === 3">
                                <form [formGroup]="propertyListingForm">
                                    <div class="overflow-auto pe-2" style="max-height: 60vh;">
                                        <div class="row g-3">
                                            <div class="col-md-6">
                                                <label class="form-label">Price</label>
                                                <input formControlName="price" class="form-control" type="number"
                                                    (focus)="handleNumberTypeFocus('price')"
                                                    (blur)="handleNumberTypeBlur('price')" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Maintenance Charge</label>
                                                <input formControlName="maintenanceCharge" class="form-control"
                                                    type="number" (focus)="handleNumberTypeFocus('maintenanceCharge')"
                                                    (blur)="handleNumberTypeBlur('maintenanceCharge')" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Deposit Amount</label>
                                                <input formControlName="depositAmount" class="form-control"
                                                    type="number" (focus)="handleNumberTypeFocus('depositAmount')"
                                                    (blur)="handleNumberTypeBlur('depositAmount')" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Available From</label>
                                                <input formControlName="availableFrom" class="form-control" type="date"
                                                    (focus)="handleNumberTypeFocus('availableFrom')"
                                                    (blur)="handleNumberTypeBlur('availableFrom')" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Posted By</label>
                                                <input formControlName="postedBy" class="form-control" type="number" />
                                            </div>

                                            <div class="flex-grow-1"></div>
                                            <div class="d-flex justify-content-end gap-2 pt-3 mt-3 border-top">
                                                <button type="button" class="btn btn-cancel px-4"
                                                    (click)="BackStep()">Back</button>
                                                <button type="button" class="btn btn-next px-4"
                                                    (click)="goToNextStep()">Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </ng-container>

                            <ng-container *ngIf="activeStep === 4">
                                <form [formGroup]="propertyListingForm">
                                    <div class="overflow-auto pe-2" style="max-height: 60vh;">
                                        <div class="row g-3">

                                            <div class="col-md-6">
                                                <label class="form-label">Role</label>
                                                <select class="form-select" formControlName="role">
                                                    <option value="">Select Role</option>
                                                    <option *ngFor="let role of userRoles" [value]="role">{{ role }}
                                                    </option>
                                                </select>
                                            </div>
                                            <!-- <div class="col-md-6">
                         <label class="form-label">Is Primary</label>
                         <input formControlName="isPrimary" class="form-control" type="checkbox" />
                     </div> -->
                                            <div class="col-md-6">
                                                <label class="form-label">Full Name</label>
                                                <input formControlName="fullName" class="form-control" type="text" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Contact Number</label>
                                                <input formControlName="contactNumber" class="form-control"
                                                    type="text" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Email</label>
                                                <input formControlName="email" class="form-control" type="email" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Agency Name</label>
                                                <input formControlName="agencyName" class="form-control" type="text" />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">RERA Registration No</label>
                                                <input formControlName="reraRegistrationNo" class="form-control"
                                                    type="text" />
                                            </div>
                                            <!-- <div class="col-md-6">
                         <label class="form-label">Verified</label>
                         <input formControlName="verified" class="form-control" type="checkbox" />
                     </div> -->
                                            <div class="flex-grow-1"></div>
                                            <div class="d-flex justify-content-end gap-2 pt-3 mt-3 border-top">
                                                <button type="button" class="btn btn-cancel px-4"
                                                    (click)="BackStep()">Back</button>
                                                <button type="button" class="btn btn-next px-4"
                                                    (click)="goToNextStep()">Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </ng-container>

                            <ng-container *ngIf="activeStep === 5">
                                <form [formGroup]="propertyMediaForm" (ngSubmit)="submitMedia()">
                                    <div class="overflow-auto pe-2" style="max-height: 60vh;">
                                        <div class="row g-3">

                                            <!-- Modern Upload Box -->
                                            <div class="col-md-12">
                                                <label class="form-label fw-bold">Upload Property Images</label>

                                                <!-- Dropzone style upload area -->
                                                <div class="upload-box border border-2 border-dashed rounded-4 p-4 text-center position-relative"
                                                    (click)="imageInput.click()"
                                                    style="cursor: pointer; background-color: #f9f9f9;">
                                                    <i class="bi bi-cloud-arrow-up fs-1 text-primary"></i>
                                                    <p class="mb-1 fw-semibold">Click or drag to upload</p>
                                                    <small class="text-muted">You can upload multiple images</small>
                                                    <input type="file" #imageInput hidden multiple accept="image/*"
                                                        (change)="onImageUpload($event)" />
                                                </div>

                                                <!-- Preview Grid -->
                                                <div class="row mt-3 g-2">
                                                    <div class="col-auto"
                                                        *ngFor="let img of imagePreviews; let i = index">
                                                        <div class="position-relative border rounded-3 shadow-sm"
                                                            style="width: 120px; height: 120px;">
                                                            <img [src]="img"
                                                                class="w-100 h-100 rounded-3 object-fit-cover" />
                                                            <button type="button"
                                                                class="btn-close btn-close-red position-absolute top-0 end-0 bg-dark rounded-circle p-1"
                                                                (click)="removeImage(i)"
                                                                style="transform: scale(0.8);"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end gap-2 pt-3 mt-4 border-top">
                                        <button type="button" class="btn btn-cancel px-4"
                                            (click)="BackStep()">Back</button>
                                        <button type="submit" class="btn btn-next px-4"
                                            (click)="goToNextStep()">Next</button>
                                    </div>
                                </form>
                            </ng-container>



                            <ng-container *ngIf="activeStep === 6">
                                <form [formGroup]="propertyMediaForm" (ngSubmit)="submitMedia()">
                                    <div class="overflow-auto pe-2" style="max-height: 60vh;">
                                        <div class="row g-3">

                                            <!-- Upload Documents -->
                                            <div class="col-md-12">
                                                <label class="form-label">Upload Documents</label>
                                                <input type="file" multiple accept=".pdf,.doc,.docx"
                                                    (change)="onDocumentUpload($event)" class="form-control" />
                                                <ul class="mt-2">
                                                    <li *ngFor="let doc of documentNames">{{ doc }}</li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end gap-2 pt-3 mt-3 border-top">
                                        <button type="button" class="btn btn-cancel px-4"
                                            (click)="BackStep()">Back</button>
                                        <button type="submit" class="btn btn-next px-4">Finish</button>
                                    </div>
                                </form>
                            </ng-container>


                            <ng-template #defaultContent>
                                <h4>{{ steps[activeStep].title }}</h4>
                                <p>{{ steps[activeStep].content }}</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>